import React from 'react';
import { Box } from '@mui/system';
import { CircularProgress } from '@mui/material';

const PageLoader = () => {
  return (
    <Box sx={{ textAlign: 'center', mt: 3 }}>
      <CircularProgress />
    </Box>
  );
};

export default PageLoader;
